import React from 'react';
import moment from 'moment';
import { Row, Col, Skeleton } from 'antd';
import UserAvatar from '@components/UserAvatar';
import { useGetApprovalWorkflow } from '@hooks/queries/approval';
import { useAuth } from '@hooks/useAuth';
import { LgWidth } from '@components/Responsive';
import { useAssetReview } from '@components/AssetReviewProvider';
import ApprovalWorkflowDeadline from '@components/MediaViewerHeader/components/ApprovalWorkflowDeadline';

function HeaderBatchInfo() {
  const { password, approvalWorkflow, commentMentions, awId } =
    useAssetReview();
  const { user } = useAuth();

  const { data: resApprovalWorkflow, isLoading: isLoadingApprovalWorkflow } =
    useGetApprovalWorkflow({
      initialData: approvalWorkflow
        ? { approvalWorkflow, commentMentions }
        : undefined,
      params: {
        id: awId || '',
        password
      }
    });

  const aw = resApprovalWorkflow?.approvalWorkflow;
  const date = aw?.createdAt;

  if (isLoadingApprovalWorkflow) {
    return <Skeleton.Input block active style={{ display: 'block' }} />;
  }

  return (
    <div className="media_viewer_header-asset-info">
      <Row gutter={16} wrap={false} align="middle">
        <Col>
          <UserAvatar
            isActive
            size="large"
            src={user?.pictureUrl || ''}
            userEmail={user?.email || ''}
            userName={user?.name || ''}
          />
        </Col>
        <LgWidth>
          <Col>
            <Row gutter={24} wrap={false} align="middle">
              <Col>
                <div className="media_viewer_header-asset-info-name">
                  Review Link{!!date && ` - ${moment(date).format('ll')}`}
                </div>
              </Col>
              <Col>
                <ApprovalWorkflowDeadline
                  approvalWorkflowId={awId || ''}
                  password={password}
                />
              </Col>
            </Row>
          </Col>
        </LgWidth>
      </Row>
    </div>
  );
}

export default HeaderBatchInfo;
